import work_1 from "../../asset/work/work1_1.jpg";
import work_2 from "../../asset/work/work1_2.jpg";
import work_3 from "../../asset/work/work1_3.jpg";
import work_4 from "../../asset/work/work2_1.jpg";
import work_5 from "../../asset/work/work2_2.jpg";
import work_6 from "../../asset/work/work2_3.jpg";
import work_7 from "../../asset/work/work2_4.jpg";
import work_8 from "../../asset/work/work2_5.jpg";
import work_9 from "../../asset/work/work2_6.jpg";
import work_10 from "../../asset/work/work3_1.jpg";
import work_11 from "../../asset/work/work3_2.jpg";
import work_12 from "../../asset/work/work3_3.jpg";
import work_13 from "../../asset/work/work3_4.jpg";
import work_14 from "../../asset/work/work6_1.jpg";
import work_15 from "../../asset/work/work6_2.jpg";
import work_16 from "../../asset/work/work6_3.jpg";
import work_17 from "../../asset/work/work6_4.jpg";
import work_18 from "../../asset/work/work6_5.jpeg";
import work_19 from "../../asset/work/work7_1.jpg";
import work_20 from "../../asset/work/work7_2.jpg";
import work_21 from "../../asset/work/work7_3.jpg";
export const  data = [
    {
        title : "1.	Conducting Baseline survey and assess the current socio-economic and environmental conditions of village",
        desc : `
        <p>In collbration with Vanrai organisation, conducted a baseline survey to assess socio-economic and environmental conditions.</p>
        <p>The Foundation was responsible for analyzing and interpreting this data to guide project planning and ensure interventions are community-specific and effective.</p>
        <p>By conserving water resources, improving farming methods, and creating sustainable livelihood opportunities, the project strives to elevate Sheri Budruk towards long-term rural development, enhanced agricultural productivity, and improved quality of life for its residents.</p>
        <div className="work_imgs">
            <img src=${work_1} class="work_img">
            <img src=${work_2} class="work_img">
            <img src=${work_3} class="work_img">
        <div>
        `
    },
    {
        title : "2.	Support of School Development - Parbhani ( Suported by MNGL)",
        desc : `
        <p>With the support of Maharashtra Natural Gas Limited (MNGL), Janpravaha Social Foundation enhanced the infrastructure of Sant Gadgebaba Ashram Shala and Late Kamalabai Vadkute Secondary School in Parbhani, benefitting over 450 students from denotified tribal and economically weaker communities.</p>
        <p>Key interventions included installing classroom benches, dormitory bunk beds, and 50 computers to foster digital literacy. As a result, 420 students gained individual seating, 250 students received improved sleeping arrangements, and computer access significantly boosted engagement and attendance. </p>
        <p>Despite initial challenges, the project was successfully implemented through strong local partnerships and is now sustained by school committees and community involvement. This initiative has not only improved student comfort and academic focus but also stands as a replicable model for rural school development</p>
        <div className="work_imgs">
            <img src=${work_4} class="work_img">
            <img src=${work_5} class="work_img">
            <img src=${work_6} class="work_img">
            <img src=${work_7} class="work_img">
            <img src=${work_8} class="work_img">
            <img src=${work_9} class="work_img">
        <div>
        `
    },
    {
        title : "3.	Youth Skilling Project - Saksham Bharat",
        desc : `
        <p>In partnership with BharatCares, implemented the Saksham Bharat project to skill youth from economically weaker sections for careers in the Banking, Financial Services, and Insurance (BFSI) sector.</p>
        <p>While BharatCares delivered classroom and on-the-job training, Janpravaha led grassroots mobilization in Pune-identifying, counseling, and enrolling 60 motivated youth. The foundation also ensured continued student engagement and readiness for employment.</p>
        <p>This collaborative effort strengthened employability among underserved youth by combining community outreach with industry-focused training, promoting economic inclusion and sustainable livelihoods.</p>
        <div className="work_imgs">
            <img src=${work_10} class="work_img">
            <img src=${work_11} class="work_img">
            <img src=${work_12} class="work_img">
            <img src=${work_13} class="work_img">
        <div>
        `
    },
    {
        title : "4.	Mission Karmayogi - a pilot project of central government",
        desc  : `
        <p>Conducted a large- scale survey to assess training needs of over 2,500 government officials (Talathis and Gramsevaks) in 6 talukas of Solapur and 4 talkas of Dharashiv districts, to support their skill upgrading and capacity building.</p>
        `
    },
    {
        title : "5.	Support of School Development – Nanded ( Suported by MNGL)",
        desc  : `
        <p>Janpravaha Social Foundation, with support from Maharashtra Natural Gas Limited (MNGL), is enhancing infrastructure across five schools and one junior college in Nanded, Maharashtra.</p>
        <p>The initiative aims to provide two-seater classroom benches and basic computer infrastructure, addressing critical gaps in student comfort and digital access.Benefiting over 2,300 students, the project focuses on improving posture, concentration, and digital literacy.</p>
        <p>Targeted institutions include schools in Umri Bazar, Pradhansangavi, Patoda (Khu), Madanapur, and Mandwa.</p>
        <p>This effort reinforces Janpravaha’s commitment to creating inclusive, student-friendly learning environments in rural and semi-urban areas.</p>
        `
    },
    {
        title : "6.	Awareness and Capacity Building under Swachh Bharat Mission 2.0 (Urban) Project",
        desc  : `
        <p>In collaboration with Kushagra Innovation Foundation, JSF coordinated with 25 ULB and 1146 school across the districts of Solapur, Sangli, Jalgaon, Nanded, Ahilyanagar and Satara to ensure smooth execution of awareness and waste management programs.</p>
        <p>The foundation provides resource persons and trained facilitators to deliver awareness sessions, capacity-building activities, and live demonstrations on waste segregation and the 5R principles (Refuse, Reduce, Reuse, Repurpose, Recycle). </p>
        <p> Waste Segregation Corners are being established in schools for hands-on learning. Regular monitoring and monthly reporting ensure smooth implementation and long-term impact.</p>
        <div className="work_imgs">
            <img src=${work_14} class="work_img">
            <img src=${work_15} class="work_img">
            <img src=${work_16} class="work_img">
            <img src=${work_17} class="work_img">
            <img src=${work_18} class="work_img">
        <div>
        `
    },
    {
        title : "7.	MIND MATTERS INITIATIVE",
        desc  : `
        <p>We Conducted session on prioritizing mental health at Khadakwadi, Pune. The session conducted for three days. There were around 200-250 girls present in session.</p>
        <p>Today’s youth face rising mental health challenges due to academic pressure, unemployment, social expectations, and digital stress. Despite this, mental health remains stigmatized, and young people lack safe platforms to express their concerns. This initiative aimed to prioritize youth mental well-being by creating open, supportive spaces for dialogue, awareness, and early support. Through interactive sessions, peer discussions, and access to counseling, the program would encourage youth to voice their concerns without fear, reduce stigma, and promote emotional resilience.</p>
        <p> By normalizing conversations around mental health and empowering youth with coping skills, the initiative sought to build a healthier, confident, and future-ready generation</p>
        <div className="work_imgs">
            <img src=${work_19} class="work_img">
            <img src=${work_20} class="work_img">
            <img src=${work_21} class="work_img">
        <div>
        `
    }
];